import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-3 text-[11px] sm:text-xs uppercase tracking-[0.3em] font-semibold text-[#D4AF37]">
    <span className="inline-block w-8 h-px bg-[#D4AF37]/70" />
    {children}
  </span>
);
